import { formatDate } from "../../lib/format-date";
import { Cart } from "../../types/Cart";
import { VCDBUser } from "../../types/VCDBUser";
import "./AdminCartCard.scss";

interface AdminCartCardProps {
  cart: Cart;
  user: VCDBUser | null;
}

const AdminCartCard: React.FC<AdminCartCardProps> = ({ cart, user }) => {
  return (
    <div className="admin-cart-card">
      <div className="admin-cart-card-header">
        <div className="admin-cart-card-header-title">
          {cart.id} &middot; {user?.email} &middot;{" "}
          {formatDate(new Date(cart.startedDate), "date-time-realtime")}
        </div>
      </div>
      <hr />
      <div className="admin-cart-card-body">
        <div className="admin-cart-card-header-status">
          Status: {cart.status === "active" ? "Active" : "Purchased"}
        </div>
        <div className="admin-cart-card-header-items">
          {cart.items.length} items
        </div>
      </div>
    </div>
  );
};

export default AdminCartCard;
